import { fetch } from '@/utils/fetch';
import { getQueryString } from '@/utils/environment';
import { checkAccountErr } from '@/api/getData';
import Vue from 'vue';
import { hlyRouter } from 'utils/routerTools';
import LoginBindHandler from 'views/login-bind/index.handler';
import store from 'src/vuex';
import { NativeService } from 'service/native/nativePluginService';

class LoginBindService {
  constructor() {
    this.needProxy = this.isWebH5Bind() || this.isMultiCloudLogin();
    return this;
  }

  //检验用户是否绑定
  //验证码验证通过以后，会二次登录
  checkoutUser(params, headers) {
    let url = '/auth/oauth/token';
    if (this.isMultiCloudLogin()) {
      url = '/proxy/oauth/token';
    }
    //钉钉自建应用唯一标识
    let appKey = getQueryString('appKey');
    if (appKey) {
      params.appKey = appKey;
    }
    const tenantId = sessionStorage.getItem('hly.multi-tenantId');
    if (tenantId) {
      params.tenant_id = tenantId;
    }
    return fetch({
      url,
      method: 'POST',
      params: params,
      headers: headers || {
        Authorization: 'Basic QXJ0ZW1pc0RpbmdUYWxrOm5MQ253ZEloaXpXYnlrSHl1Wk02VHBRRGQ3S3dLOUlYREs4TEdzYTdTT1c=',
      },
    });
  }

  //检验用户是否绑定 （公众号 体验登录）
  checkoutTrialUser(params) {
    return fetch({
      url: '/auth/oauth/token',
      method: 'POST',
      params: params,
    });
  }

  //获取图片验证码
  getImageConfirmCode(login) {
    let params = '';
    let url = '/api/refactor/user/verify/code';
    if (this.needProxy) {
      url = '/proxy/api/refactor/user/verify/code';
      params = {
        login,
        client: this.getLoginClient(),
        cryptType: '4.0',
      };
    }
    return fetch({
      url,
      method: 'GET',
      params,
    });
  }

  //获取图片验证码 （公众号 体验登录）
  getTrialImageConfirmCode() {
    let timestamp = Date.parse(new Date());
    return fetch({
      url: '/api/companies/register/verify/code?time=' + timestamp + '&roleType=TENANT',
      method: 'GET',
      params: '',
    });
  }

  //是否纯Web页面H5绑定
  isWebH5Bind() {
    return (getQueryString('redirect') || '').includes('xiaojukeji');
  }

  //解决微信服务号的多云问题，没有标志，所以要用proxy
  //企业微信解决方案 使用v1转发 header会有corpId
  //钉钉解决方案 使用v1转发 header会有标志
  isMultiCloudLogin() {
    return getQueryString('loginType') === 'wxmp';
  }

  getLoginClient() {
    let client = 'webapp';
    if (getQueryString('loginType') === 'wxmp') {
      client = 'wxfw';
    }
    return client;
  }

  //获取验证码
  getConfirmCode(params) {
    let url = '/api/refactor/wechat/activation/login/token';
    if (this.needProxy) {
      url = '/proxy/api/refactor/wechat/activation/login/token';
      params.client = this.getLoginClient();
    }
    const tenantId = sessionStorage.getItem('hly.multi-tenantId');
    if (tenantId) {
      params.tenantId = tenantId;
    }
    return fetch({
      url,
      method: 'GET',
      params: params,
    });
  }

  //获取验证码（公众号 体验登录）
  getTrialConfirmCode(params) {
    return fetch({
      url: '/api/trialService/ft/mobile/token',
      method: 'GET',
      params: params,
    });
  }

  // 获取重置密码的验证码
  getResetConfirmCode(params) {
    let url = '/api/refactor/account/reset_password/init/v4';
    if (this.needProxy) {
      url = '/proxy/api/refactor/account/reset_password/init/v4';
    }
    return fetch({
      url,
      method: 'GET',
      params,
    });
  }

  // 不通过图片验证获取的验证码
  getNotImgConfirmCode(account) {
    const params = {
      login: LoginBindHandler.encryptAES(account),
      client: 'app',
      cryptType: '2.3',
    };
    let url = '/api/refactor/account/reset_password/init/no/yzm/v4';
    if (this.needProxy) {
      url = '/proxy/api/refactor/account/reset_password/init/no/yzm/v4';
    }
    return fetch({
      url,
      method: 'GET',
      params,
    });
  }

  // 判断验证码是否正确
  judgeConfirmCode(data) {
    let url = '/api/refactor/account/reset_password/check/v3';
    if (this.needProxy) {
      url = '/proxy/api/refactor/account/reset_password/check/v3';
    }
    return fetch({
      url,
      method: 'POST',
      data,
    });
  }

  // 获取密码设置规则
  getPasswordRule(username) {
    const data = {
      username: LoginBindHandler.encryptAES(username),
      needProtocolI18n: 0,
      client: 'app',
      cryptType: '2.3',
    };
    const tenantId = sessionStorage.getItem('hly.multi-tenantId');
    if (tenantId) {
      data.tenantId = tenantId;
    }
    let url = '/api/refactor/password/rule/topic/v2';
    if (this.needProxy) {
      url = '/proxy/api/refactor/password/rule/topic/v2';
    }
    return fetch({
      url,
      method: 'POST',
      data,
    });
  }

  // 重置密码
  resetPassword(data) {
    let url = '/api/refactor/reset/password/bind/email/or/mobile';
    if (this.needProxy) {
      url = '/proxy/api/refactor/reset/password/bind/email/or/mobile';
    }
    return fetch({
      url,
      method: 'POST',
      data,
    });
  }

  // 修改密码
  modifyPassword(data) {
    let url = '/api/refactor/account/change_password/v4';
    if (this.needProxy) {
      url = '/proxy/api/refactor/account/change_password/v4';
    }
    return fetch({
      url,
      method: 'POST',
      data,
    });
  }

  //密码登录
  passwordLogin(params, headers) {
    //钉钉自建应用唯一标识
    let appKey = getQueryString('appKey');
    if (appKey) {
      params.appKey = appKey;
    }
    const tenantId = sessionStorage.getItem('hly.multi-tenantId');
    if (tenantId) {
      params.tenant_id = tenantId;
    }
    return fetch({
      url: '/auth/oauth/token',
      method: 'POST',
      params: params,
      headers: headers
        ? headers
        : {
            Authorization: 'Basic QXJ0ZW1pc0RpbmdUYWxrOm5MQ253ZEloaXpXYnlrSHl1Wk02VHBRRGQ3S3dLOUlYREs4TEdzYTdTT1c=',
          },
    });
  }

  //密码登录
  passwordLoginMultipleCloud(params, headers) {
    return fetch({
      url: '/proxy/oauth/token',
      method: 'POST',
      params: params,
      headers: headers
        ? headers
        : {
            Authorization: 'Basic QXJ0ZW1pc0RpbmdUYWxrOm5MQ253ZEloaXpXYnlrSHl1Wk02VHBRRGQ3S3dLOUlYREs4TEdzYTdTT1c=',
          },
    });
  }

  //验证码登录
  confirmCodeLoginWithoutCheck(params, headers) {
    //钉钉自建应用唯一标识
    let appKey = getQueryString('appKey');
    if (appKey) {
      params.appKey = appKey;
    }
    const tenantId = sessionStorage.getItem('hly.multi-tenantId');
    if (tenantId) {
      params.tenant_id = tenantId;
    }
    return fetch({
      url: '/auth/oauth/token',
      method: 'POST',
      params: params,
      headers: headers,
    });
  }

  //验证码登录
  confirmCodeLogin(params, account, headers) {
    let url = '/api/refactor/wechat/activation/login/check';
    if (this.isWebH5Bind()) {
      url = '/proxy/oauth/token';
      let account1 = LoginBindHandler.encryptAES(account);
      params.login = account1;
      params.password = account1;
      params.client = 'app';
      return fetch({
        url,
        method: 'POST',
        params,
        headers: headers
          ? headers
          : {
              Authorization: 'Basic QXJ0ZW1pc0RpbmdUYWxrOm5MQ253ZEloaXpXYnlrSHl1Wk02VHBRRGQ3S3dLOUlYREs4TEdzYTdTT1c=',
            },
      });
    } else {
      if (this.isMultiCloudLogin()) {
        //目前是微信服务号的特殊逻辑, proxy多云处理不支持body的传参，需要放在url上
        url = '/proxy/api/refactor/wechat/activation/login/check';
        params.client = this.getLoginClient();
        return fetch({
          url,
          method: 'POST',
          params: {
            login: params.login,
            cryptType: params.cryptType,
            client: params.client,
          },
          data: params,
        });
      }
      //钉钉自建应用唯一标识
      let appKey = getQueryString('appKey');
      if (appKey) {
        params.appKey = appKey;
      }
      const tenantId = sessionStorage.getItem('hly.multi-tenantId');
      if (tenantId) {
        params.tenantId = tenantId;
      }
      return fetch({
        url,
        method: 'POST',
        data: params,
      });
    }
  }

  //验证码登录（公众号 体验登录）
  confirmTrialCodeLogin(params) {
    return fetch({
      url: '/api/trialService/ft/mobile/token/check',
      method: 'GET',
      params: params,
    });
  }

  //设置手机号或邮箱,获取验证码
  setPhoneGetCode(params) {
    return fetch({
      url: '/api/refactor/set/mobile/token/v3',
      method: 'GET',
      params: params,
    });
  }
  //设置手机号或邮箱,获取验证码
  updatePhoneGetCode(params) {
    return fetch({
      url: '/api/refactor/update/mobile/token/v3',
      method: 'GET',
      params: params,
    });
  }
  setEmailGetCode(params) {
    return fetch({
      url: '/api/refactor/update/mobile/token/v3',
      method: 'GET',
      params: params,
    });
  }

  //设置手机号
  setPhone(params) {
    return fetch({
      url: '/api/refactor/set/mobile/finish/v3',
      method: 'POST',
      data: params,
    });
  }

  //设置手机号
  updatePhone(params) {
    return fetch({
      url: '/api/refactor/update/mobile/finish/v3',
      method: 'POST',
      data: params,
    });
  }
  //验证手机号
  validatePhone(params) {
    return fetch({
      url: '/api/refactor/validate/mobile/finish/v3',
      method: 'POST',
      data: params,
    });
  }

  //设置邮箱
  setEmail(params) {
    return fetch({
      url: '/api/refactor/update/mobile/finish/v3',
      method: 'POST',
      data: params,
    });
  }

  //设置后重新刷新信息
  refreshAccount() {
    return fetch({
      url: '/api/account',
      method: 'GET',
    }).catch((err) => {
      checkAccountErr(err);
      throw err;
    });
  }

  //解绑服务号
  unbindWeChatService(params) {
    let appKey = getQueryString('agentId') || getQueryString('appId') || getQueryString('appKey');
    if (appKey) {
      params.appKey = appKey;
    }
    return fetch({
      url: '/auth/api/wechat/logout',
      method: 'POST',
      params,
    });
  }

  unbindService(needGoBack = true) {
    let loginType = getQueryString('loginType');
    let isTrial = getQueryString('isTrial');
    Vue.prototype.$plugins.showLoading();
    let map = {
      feishu: { clientType: 'feishu' },
      yzj: { clientType: 'yzj' },
      dd: { clientType: 'dingTalk' },
      wxmp: { clientType: 'wxserviceaccount' },
      wx: { clientType: 'wechat' },
      welink: { clientType: 'welink' },
    };
    let params = map[loginType] || { clientType: 'wxserviceaccount' };
    if (isTrial === 'Y') {
      params.isTrial = true;
    }
    // 解绑时清除guide缓存
    window.localStorage.removeItem('hlyV2HideRefactorMainGuide');
    window.localStorage.removeItem('hlyV2HideApplicationManageGuide');
    this.unbindWeChatService(params).then(
      (res) => {
        Vue.prototype.$plugins.hideLoading();
        if (res.status === 200) {
          if (loginType === 'feishu') {
            NativeService().closeWindow();
            // let appId = getQueryString('appId'),
            //   corpId = getQueryString('corpId') || sessionStorage.getItem('corpId');
            // let url = `https://open.feishu.cn/open-apis/authen/v1/index?redirect_uri=${encodeURIComponent(
            //   `${window.location.origin}/?corpId=${corpId}&appId=${appId}&loginType=feishu&isTrial=${
            //     isTrial || 'N'
            //   }&isBindMessage=true&show_right_button=false`
            // )}&app_id=${appId}`;
            // setTimeout(() => {
            //   location.replace(url);
            // }, 100);
          } else if (loginType === 'wx' && store.getters.storesWeCom) {
            try {
              const infos = JSON.parse(sessionStorage.getItem('hly.wx.app.info'));
              const { corpId, agentId } = infos;
              const redirectUrl = `https://www.huilianyi.com/huilianyi-wechat/?corpId=${corpId}&companyStr=&loginType=wx`;
              const url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${corpId}&redirect_uri=${encodeURIComponent(
                redirectUrl
              )}&response_type=code&scope=snsapi_privateinfo&agentid=${agentId}&state=STATE#wechat_redirect`;
              setTimeout(() => {
                location.replace(url);
              }, 100);
            } catch (e) {
              NativeService().closeWindow();
            }
          } else if (['wx', 'wxmp', 'yzj'].includes(loginType)) {
            NativeService().closeWindow();
          } else {
            if (needGoBack) hlyRouter.go(-2);
            setTimeout(() => {
              if (isTrial) hlyRouter.replace({ name: 'trialLogin' });
              else hlyRouter.replace({ name: 'accountLogin' });
            }, 1000);
          }
        }
      },
      (err) => {
        if (['wx', 'wxmp', 'yzj'].includes(loginType)) {
          NativeService().closeWindow();
        }
        Vue.prototype.$plugins.hideLoading();
      }
    );
  }

  //删除手机号
  deletePhone(params) {
    return fetch({
      url: `/api/refactor/mobile/unbind/v2?mobile=${params}`,
      method: 'POST',
    });
  }
  getCodeValidate(params) {
    return fetch({
      url: '/api/refactor/validate/mobile/token/v3',
      method: 'GET',
      params,
    });
  }

  getAuthorSign(params) {
    return fetch({
      url: '/v1/api/receipt/didi/sign/generate',
      method: 'GET',
      params,
    });
  }
  deviceSecurityVerify(param) {
    return fetch({
      url: `/api/refactor/devicebind/bind?deviceId=&token=${param.token}&login=${param.login}&cryptType=4.0`,
      method: 'GET',
    });
  }
  getVerifySecurityCode(params) {
    const tenantId = sessionStorage.getItem('hly.multi-tenantId');
    if (tenantId) {
      params.tenantId = tenantId;
    }
    return fetch({
      url: '/api/refactor/devicebind/email/or/mobile/token',
      method: 'GET',
      params,
    });
  }
  logout() {
    let appKey = getQueryString('agentId') || getQueryString('appId') || getQueryString('appKey');
    let data = {};
    if (appKey) {
      data.appKey = appKey;
    }
    return fetch({
      url: '/api/logout?roleType=TENANT',
      method: 'POST',
      params: data,
    });
  }

  // 获取区号
  getCountryCode() {
    return fetch({
      url: '/api/mobilevalidate/list',
      method: 'GET',
      params: { isEnabled: false },
    });
  }
}

export default new LoginBindService();
